import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, IconButton, Button } from "@mui/material";
import AddNotification from "../../Modals/addNotification";
import AddIcon from '@mui/icons-material/Add';
import NotificationsList from "../../features/manageNotifications/notificationsList";

const ManageNotifications = () => {

    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <MainContainer>
            <div className="main_title d_flex">
                <h1>Manage Notifications</h1>
                <div className="right_s">
                      <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                        />
                    </div>
                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => setOpenModal(true)}><AddIcon /> Add Notification</Button>
                    </div>
                </div>
                </div>
          
            </div>

            <div className="cards table_cards">
              

                <NotificationsList />
            </div>

            <AddNotification open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
        </MainContainer>
    );
};

export default ManageNotifications;
